import {
  STAGE_DATA_COMPLETED,
  STAGE_DATA_COMPLETED_LAWFIRM,
  STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT,
  STAGE_WAITING_FOR_FEEDBACK,
} from "../../Stages/StagesCase";
import {
  previewCaseRejectedMessageButton,
  previewClaimLetterButton,
  previewFeedbackMessageButton,
} from "./litigationCaseDetailsSpecialActions";
import { RentalContract } from "../../../types/Products/RentalContract";

export const rentalContractCaseDetailsSpecialActions = (product: RentalContract) => {
  let specialActions = [];
  if (
    (product.stage === STAGE_DATA_COMPLETED || product.stage === STAGE_WAITING_FOR_FEEDBACK) &&
    product.caseCategoryAssessment === "reject" &&
    product.assessmentRejectionText
  ) {
    specialActions.push(previewCaseRejectedMessageButton(product));
  }

  if (product.stage === STAGE_DATA_COMPLETED_LAWFIRM) {
    specialActions.push(previewClaimLetterButton(product));
  }

  if (product.stage === STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT) {
    specialActions.push(previewFeedbackMessageButton(product));
  }

  if (specialActions.length === 0) {
    return null;
  }

  return specialActions;
};
